/**
 * product-bis.js — 再入荷通知（Klaviyo 純正 Back In Stock / variant 単位）
 *
 * 方式: 案B（MIK-349 / ADR-0013 Develop-first）
 * - snippets/product-bis.liquid が出力する [data-product-bis] ブロックの送信ボタンを
 *   document レベルのイベント委譲で待ち受ける。
 *   → product-info.js の updateSourceFromDestination('ProductBIS') で
 *     ラッパー innerHTML が variant 切替時に丸ごと差し替わっても、リスナーは生き続ける。
 * - 送信時、その時点でブロックに付いている data-variant-id（＝選択中 variant）を読み、
 *   Klaviyo Client Back In Stock Subscription API を variant 指定で叩く。
 *
 * Klaviyo Client BIS API:
 *   POST https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id={SITE_ID}
 *   - 認証不要のクライアントエンドポイント（company_id は公開 Site ID、秘密鍵ではない）
 *   - revision ヘッダ必須（安定版を使用）
 *   - variant id 形式: $shopify:::$default:::{shopifyVariantId}
 *   - channels: ["EMAIL"], profile.email: 入力値
 *   - 成功時 202 Accepted（ボディなし）
 */
(function () {
  'use strict';

  // Klaviyo Client API の安定 revision（公式ドキュメント記載の安定版）。
  // 将来 revision 更新時はここだけ差し替える。
  var KLAVIYO_REVISION = '2026-04-15';
  var KLAVIYO_BIS_ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/';

  // 二重バインド防止（asset が複数回読まれてもリスナーは 1 つ）
  if (window.__productBisBound) return;
  window.__productBisBound = true;

  function isValidEmail(value) {
    // 簡易バリデーション（厳密判定はサーバ側 Klaviyo に委ねる）
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function setState(wrapper, state) {
    var success = wrapper.querySelector('[data-bis-success]');
    var error = wrapper.querySelector('[data-bis-error]');
    if (success) success.hidden = state !== 'success';
    if (error) error.hidden = state !== 'error';
  }

  function buildPayload(variantId, email) {
    return {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email },
            },
          },
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              // Shopify 連携カタログの variant 識別子形式
              id: '$shopify:::$default:::' + variantId,
            },
          },
        },
      },
    };
  }

  function submit(wrapper) {
    var emailInput = wrapper.querySelector('[data-bis-email]');
    var button = wrapper.querySelector('[data-bis-submit]');
    var variantId = wrapper.getAttribute('data-variant-id');
    var companyId = wrapper.getAttribute('data-company-id');
    var email = emailInput ? emailInput.value.trim() : '';

    if (!variantId || !companyId) {
      setState(wrapper, 'error');
      return;
    }

    if (!isValidEmail(email)) {
      // メール未入力／不正はネイティブ表示に寄せる
      if (emailInput) emailInput.reportValidity();
      return;
    }

    // 二重送信防止
    if (button) button.disabled = true;
    setState(wrapper, 'idle');

    var url = KLAVIYO_BIS_ENDPOINT + '?company_id=' + encodeURIComponent(companyId);

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: KLAVIYO_REVISION,
      },
      body: JSON.stringify(buildPayload(variantId, email)),
    })
      .then(function (response) {
        if (response.ok) {
          // 202 Accepted
          setState(wrapper, 'success');
          if (emailInput) emailInput.value = '';
        } else {
          setState(wrapper, 'error');
          if (button) button.disabled = false;
        }
      })
      .catch(function () {
        setState(wrapper, 'error');
        if (button) button.disabled = false;
      });
  }

  // イベント委譲: クリック（送信ボタン）
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-bis-submit]');
    if (!trigger) return;
    var wrapper = trigger.closest('[data-product-bis]');
    if (!wrapper) return;
    event.preventDefault();
    submit(wrapper);
  });

  // イベント委譲: Enter キー（メール入力で送信）
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var input = event.target.closest('[data-bis-email]');
    if (!input) return;
    var wrapper = input.closest('[data-product-bis]');
    if (!wrapper) return;
    event.preventDefault();
    submit(wrapper);
  });
})();
